<template>
  <div
    v-if="squareMinMax[0] !== null && squareMinMax[1] !== null"
    class="plans-filter-area"
  >
    <div class="plans-filter-area__label">Площадь, м²</div>
    <CustomSlider
      v-model="squareFilter"
      :min="squareMinMax[0]"
      :max="squareMinMax[1]"
      :format="squareFilterFormat"
    />
  </div>
</template>

<script>
import CustomSlider from "@/components/CustomSlider.vue";
import _minBy from "lodash/minBy";
import _maxBy from "lodash/maxBy";

export default {
  components: {
    CustomSlider,
  },

  inject: ["filterStore"],

  props: {
    flats: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {
      squareFilter: [null, null],
      squareMinMax: [null, null],
    };
  },

  computed: {
    squareFilterActive() {
      return this.filterStore.state.filterSquare;
    },
  },

  watch: {
    flats: {
      handler(newFlats) {
        if (newFlats && newFlats.length > 0) {
          this.setSquareMinMax(newFlats);
        }
      },
      immediate: true,
    },
    squareFilter: {
      handler(newValue) {
        if (newValue[0] !== null && newValue[1] !== null) {
          this.filterStore.setFilterSquare(newValue);
        }
      },
      deep: true,
    },
  },

  mounted() {
    if (this.flats.length > 0) {
      this.setSquareMinMax(this.flats);
    }
    if (this.squareFilterActive && this.squareFilterActive[0] !== null) {
      this.squareFilter = this.squareFilterActive;
    }
  },

  methods: {
    squareFilterFormat(value) {
      return value.toFixed(1);
    },

    setSquareMinMax(flats) {
      if (flats && flats.length > 0) {
        let squareMin = _minBy(flats, "layout.area")?.layout.area;
        let squareMax = _maxBy(flats, "layout.area")?.layout.area;
        if (typeof squareMin === "number" && typeof squareMax === "number") {
          this.squareMinMax = [squareMin, squareMax];
          if (!this.squareFilterActive || this.squareFilterActive[0] === null) {
            this.squareFilter = [squareMin, squareMax];
          }
        }
      }
    },
  },
};
</script>

<style scoped>
.plans-filter-area {
  display: flex;
  flex-direction: column;
  gap: 10px;
  flex: 1;
}

.plans-filter-area__label {
  font-weight: 500;
  font-size: 14px;
  color: #291f1f;
}

@media (max-width: 768px) {
  .plans-filter-area__label {
    font-size: 12px;
  }
}
</style>
